import React from "react";
import QuoteDetailContent from "../QuoteDetailContent";

export default function ViewQuoteDetail() {
  return <QuoteDetailContent />;
}
